
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.71 5.527L7.837 9.902a.627.627 0 01-.671 0L.29 5.527a.626.626 0 010-1.054L7.165.097a.626.626 0 01.67 0l6.876 4.376a.624.624 0 010 1.054z"}}),_c('path',{attrs:{"d":"M.29 9.472L2.225 8.24l4.268 2.716a1.878 1.878 0 002.012.001l4.27-2.717 1.936 1.232a.626.626 0 010 1.054l-6.875 4.376a.625.625 0 01-.671 0L.29 10.526a.624.624 0 010-1.054z"}})])
          )
        }
      }
    